/**
 * ผาดาบชาด (สำนักดาบชาด): dark and driven. A low zheng ostinato that will not stop, the pipa
 * in tremolo above it, big drums; the flat second (b7 in 1 = C, above the 羽 tonic A) for menace.
 */
import { drone } from '../compose';
import { registerTrack } from '../registry';

const OST = `6,,_ 6,,_ 3,_ 6,,_ b7,,_ 6,,_ 3,_ 5,,_`;
const OST_E = `3,,_ 3,,_ 6,,_ 3,,_ 5,,_ 3,,_ 6,,_ 2,_`;
const A_PIPA = `@f 6%- 1'_ 6_ 5 | 3_ 5_ 3_ 2_ 3- | 6%- 1'_ 2'_ 3' | 2'_ 1'_ 6 6%- |
  3'!. 2'_ 1' 6 | b7_ 6_ 5_ 3_ 6- | 1'_ 6_ 5_ 3_ 2_ 3_ 1_ 2_ | 6,%---`;
const BEAT = `D_ 0_ D_ d_ 0_ d_ D_ d_`;
const DRUMS_A = [BEAT, BEAT, BEAT, BEAT, BEAT, BEAT, BEAT, `D_ D_ D_ D_ G-`].join(' | ');

const B_ZHENG = `@f 6,g 6,_ 1_ 2 3 | 2_ 1_ 6,_ 5,_ 6,/- | 3. 5_ 6 b7^ | 6%--- |
  1'. 6_ 5 3 | 5_ 6_ 5_ 3_ 2\\- | 3_ 2_ 1_ 2_ 3 5, | 6,%---`;
const PIPA_B = `6,_ 3_ 6,_ 3_ 5,_ 3_ 6,_ 3_`;
const DRUMS_B = [`G&D_ 0_ 0_ d_ D_ 0_ d_ d_`, ...Array(7).fill(`D_ 0_ 0_ d_ D_ 0_ d_ d_`)].join(' | ');

registerTrack({
  id: 'cinnabar',
  order: 11,
  title: 'ผาดาบชาด',
  mood: 'มืดมน ดุดัน เร่งเร้า',
  use: 'ผาดาบชาด (สำนักดาบชาด) ทั้งกลางวันและกลางคืน',
  key: 'C',
  mode: 'yu',
  bpm: 112,
  meter: 4,
  seed: 1111,
  humanize: 0.3,
  parts: {
    pipa: { inst: 'pipa', pan: 0.15, reverb: 0.3 },
    zheng: { inst: 'zheng', pan: -0.1, reverb: 0.3 },
    bass: { inst: 'zheng', gain: 0.6, pan: -0.2, reverb: 0.15 },
    pad: { inst: 'pad', gain: 0.9, reverb: 0.4 },
    drums: { inst: 'perc', gain: 0.5, reverb: 0.25 },
  },
  sections: {
    A: {
      bars: 8,
      parts: {
        pipa: A_PIPA,
        bass: `@mf ${[OST, OST, OST, OST, OST_E, OST_E, OST, OST].join(' | ')}`,
        pad: drone(`6,, 6,, 6,, 6,, 3,, 3,, 6,, 6,,`, 4),
        drums: DRUMS_A,
      },
    },
    B: {
      bars: 8,
      parts: {
        zheng: B_ZHENG,
        pipa: `@mp ${Array(8).fill(PIPA_B).join(' | ')}`,
        bass: `@mf 6,,--- | 6,,--- | 3,,--- | 6,,--- | 1,--- | 5,,--- | 3,,--- | 6,,---`,
        pad: drone(`6,, 6,, 3,, 6,, 1, 5,, 3,, 6,,`, 4),
        drums: DRUMS_B,
      },
    },
    C: {
      bars: 4,
      parts: {
        pipa: `@f 3%--- | 5%--- | 6%--- | 1'%- 3'!-`,
        bass: `@mf ${[OST, OST, OST, OST].join(' | ')}`,
        drums: `G--- | D D D D | D_ D_ D_ D_ D D | D_ D_ D_ D_ d_ d_ d_ d_`,
      },
    },
  },
  form: ['A', 'B', 'A', 'C', 'B', 'A'],
  loop: true,
});
